/**
 * Confirmação curta no prontuário — paciente já conhecido, sem wizard de agenda.
 */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

interface EvolutionConfirmDialogProps {
  open: boolean;
  patientDisplay?: string;
  professionalDisplay?: string;
  hasOpenEvolution?: boolean;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/** Legível ao lado das tabelas de insights (evita body2 ~14px). */
const DIALOG_TITLE_SX = { fontSize: "1.25rem", fontWeight: 700, lineHeight: 1.35 } as const;
const DIALOG_PATIENT_SX = { fontSize: "1.125rem", fontWeight: 600, lineHeight: 1.45 } as const;
const DIALOG_SECONDARY_SX = { fontSize: "1rem", lineHeight: 1.45 } as const;
const DIALOG_BODY_SX = { fontSize: "1.0625rem", lineHeight: 1.5 } as const;
const DIALOG_ACTION_SX = { textTransform: "none", fontSize: "1.0625rem" } as const;

export function EvolutionConfirmDialog({
  open,
  patientDisplay,
  professionalDisplay,
  hasOpenEvolution = false,
  loading = false,
  onClose,
  onConfirm,
}: EvolutionConfirmDialogProps) {
  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={DIALOG_TITLE_SX}>
        {hasOpenEvolution ? "Continuar evolução" : "Evoluir paciente"}
      </DialogTitle>
      <DialogContent dividers>
        {patientDisplay && (
          <Typography component="p" sx={DIALOG_PATIENT_SX}>
            Paciente: {patientDisplay}
          </Typography>
        )}
        {professionalDisplay && (
          <Typography component="p" color="text.secondary" sx={{ mt: 0.75, ...DIALOG_SECONDARY_SX }}>
            Profissional: {professionalDisplay}
          </Typography>
        )}
        <Typography component="p" sx={{ mt: 2, ...DIALOG_BODY_SX }}>
          {hasOpenEvolution
            ? "Há uma evolução em aberto. Você continuará o atendimento sem criar outro agendamento."
            : "Será criada uma evolução sem custo e o atendimento será iniciado agora."}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading} sx={DIALOG_ACTION_SX}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={onConfirm}
          disabled={loading}
          sx={{ ...DIALOG_ACTION_SX, fontWeight: 700 }}
        >
          {loading ? "Iniciando..." : "Confirmar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
